import { GPSStandardSettings } from 'apps/studio/components/settings/fields/GPS/standard'
import { FieldSettingsPanel } from 'apps/studio/components/settings/fields/Base/standard'
import { DesignSettingsPanel } from 'apps/studio/components/settings/fields/Base/design'
import { AdvancedPanel } from 'apps/studio/components/settings/fields/GPS/advanced'

export const GPSSettings = [
  FieldSettingsPanel(GPSStandardSettings),
  DesignSettingsPanel,
  // ConditionsPanel,
  AdvancedPanel,
]
